export enum MoneyAccountType {
Bank,
Cash,
Other,
}
